module.exports = __webpack_public_path__ + "media/images/category/feature/echigo/ojiya-1e06acc34bb1f4d5792dd5ef862eb902.gif";